export function splitProductTitle(title: string): string[] {
  return title.split("|").map((part) => part.trim()).filter(Boolean)
}

export function shortProductName(title: string): string {
  return splitProductTitle(title)[0] ?? title.trim()
}
